'use strict';

const debounce = (ms) => (fn) => {
    let timeout;
    const enhancedFn = ((...args) => {
        if (timeout)
            globalThis.clearTimeout(timeout);
        timeout = globalThis.setTimeout(() => fn(...args), ms);
    });
    return enhancedFn;
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { };

exports.debounce = debounce;
exports.noop = noop;
//# sourceMappingURL=functions.js.map
